import clsx from 'clsx'

import { useModalContext } from './ModalContext'

import styles from './ModalTitle.module.scss'

type ModalTitleProps = {
  visuallyHidden?: boolean
  children: React.ReactNode
}

export const ModalTitle = ({
  visuallyHidden = false,
  children
}: ModalTitleProps) => {
  const context = useModalContext()

  if (!context) {
    throw new Error('ModalTitle must be used inside a <Modal> component.')
  }

  return (
    <h2
      id={`${context.id}-label`}
      className={clsx(styles.title, { 'visually-hidden': visuallyHidden })}
    >
      {children}
    </h2>
  )
}

export default ModalTitle
